import { ENGLISH_LANG_CODE } from "@evennt-tech/api-v2-core";

export const resolveCacheLanguage = (
  languageByShowId: Record<string, string>,
  showId: string,
  languageCode?: string
): string => languageCode ?? languageByShowId[showId] ?? ENGLISH_LANG_CODE;

export const languageCodeQuery = (languageCode: string) =>
  languageCode === ENGLISH_LANG_CODE
    ? {}
    : ({ languageCode } as { languageCode?: string });

/**
 * Per-show request counter used to discard superseded responses: a language
 * change bypasses the stores' `isLoading` dedupe, so two requests for different
 * languages can be in flight at once and the last one must win.
 */
export const createRequestSeq = () => {
  const seq: Record<string, number> = {};

  return (showId: string) => {
    seq[showId] = (seq[showId] ?? 0) + 1;
    const requestId = seq[showId];

    return () => seq[showId] === requestId;
  };
};
